import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-wifi",
  "use": "icon-icon-wifi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-wifi\"><path d=\"M214 554c166-164 432-164 596 0L726 640C608 522 416 522 298 640zM384 726c70-70 186-70 256 0l-128 128zM42 384c260-258 682-258 940 0L896 470c-212-212-556-212-768 0z\" p-id=\"2316\" fill=\"#000000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol